import { useQuery } from '@apollo/client';
import useAccount from 'shared/domains/users/hooks/useAccount';
import { FEATURES_QUERY } from './query';
export function useFeatures() {
    var _a, _b, _c, _d;
    const account = useAccount();
    const companyId = (_a = account.data) === null || _a === void 0 ? void 0 : _a.companyId;
    const { data } = useQuery(FEATURES_QUERY, {
        variables: { companyId },
    });
    return (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.company) === null || _b === void 0 ? void 0 : _b.market.features) === null || _c === void 0 ? void 0 : _c.map(({ id }) => id)) !== null && _d !== void 0 ? _d : [];
}
